<template>
  <g fill-rule="evenodd">
    <path
      d="M15.54 7.36a3.68 3.68 0 00-4.28-2.72 4.77 4.77 0 00-8.38 3.08 4.04 4.04 0 001.66 7.72h1.9a.8.8 0 00.8-.8.8.8 0 00-.8-.8h-1.9a2.44 2.44 0 01-.62-4.8c.38-.1.64-.48.6-.88-.02-.16-.02-.28-.02-.4a3.18 3.18 0 015.82-1.78c.2.3.6.42.94.3a2.08 2.08 0 012.8 1.94c0 .24.12.46.3.6.18.14.42.2.66.16.16-.02.3-.04.44-.04 1.34 0 2.44 1.1 2.44 2.44 0 1.34-1.1 2.48-2.44 2.48h-1.9a.8.8 0 00-.8.8c0 .44.36.8.8.8h1.9a4.04 4.04 0 00.08-8.1"
    />
    <path
      d="M13 11.52l-2.64-3.58a.45.45 0 00-.74 0l-2.64 3.58c-.22.32 0 .74.38.74h1.48v3.85c0 .27.2.46.46.46h1.38c.26 0 .46-.2.46-.46v-3.85h1.48c.38 0 .6-.45.38-.74"
    />
  </g>
</template>

<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
  name: "PublishIcon",
});
</script>
